import styled, {keyframes, css} from 'styled-components';
import { device } from '../../../utils/responsive_utilities';
import { Perano, Perfume, indigo, royal, VividViolet } from '../../loggedout/shared-styles/Colors';
const conceptAnimation = keyframes`
  0% {
    opacity: 1;
    transform: translateX(-7rem);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;
const practiceAnimation = keyframes`
  0% {
    opacity: 1;
    transform: translate(7rem, -1rem);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`;

const conceptAnimationRowWise = (animationYOffset) => keyframes`
  0% {
    opacity: 1;
    transform: translateY(-${animationYOffset}px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const practiceAnimationRowWise = (animationYOffset, pausePosition) => keyframes`
  0% {
    opacity: 1;
    transform: translateY(-${animationYOffset}px);
  }

  40%{
    opacity: 1;
    transform: translateY(${-(animationYOffset - pausePosition)}px);
  }

  70%{
    opacity: 1;
    transform: translateY(${-(animationYOffset - pausePosition)}px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const skillCardRotation1 = keyframes`
  0% {
    opacity: 1;
    transform: rotate(5deg);
  }
  50% {
    opacity: 1;
    transform: rotate(-5deg);
  }
  100% {
    opacity: 1;
    transform: rotate(5deg);
  }
`;
export const skillCardRotation2 = keyframes`
  0% {
    opacity: 1;
    transform: rotate(-5deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  100% {
    opacity: 1;
    transform: rotate(-5deg);
  }
`;

export const SkillCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.8rem;
  width: ${props => props.cardWidth+'px'};
  max-height: 15rem;
  height: ${props => props.cardHeight+'px'};
  border-radius: 1.6rem;
  background: ${props=>props.colorCat==="practice_and_master" ? Perano: Perfume};
  box-shadow: 0 0.4rem 0 rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  position: absolute;
  z-index: 1;
  opacity: ${props=>props.buildLearningPath ? 1 : 0 };
  left: ${props=>props.sideH ? props.sideH: 0};
  top: ${props=>props.sideV ? props.sideV : 0};
  transition: left 1s ease-out, top 1s ease-out;
  text-align: left;

  @media ${device.PhoneTabletLandscape}{
    padding: 0.5rem;
    border-radius: 0.9rem;
    flex-direction: row;
    ${props => props.buildLearningPath ? css`
      height:9rem;
      width: 12rem;
      flex-direction: column
    ` : ``}
  }

  &.cat-practice_and_master {
    ${props => props.rowWise ? css`
      animation: ${practiceAnimationRowWise(props.animationYOffset, props.pausePosition)} 2s ${props.delay + 's'} ease-in-out forwards;`
    : css`
      animation: ${practiceAnimation} 2s 1s ease-in-out forwards;
    `}
  }
  &.cat-build_concepts {
    ${props => props.rowWise ? css`animation: ${conceptAnimationRowWise(props.animationYOffset)} 2s ${props.delay + 's'} ease-in-out forwards;`
    : css`
      animation: ${conceptAnimation} 2s 1s ease-in-out forwards;
    `}
  }
  &.card-1 {
    left: 18rem;
    top: 12rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation1} 2s ${props.rowWise ? '4.5s' : '2s'} infinite`: null};
    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 12rem;
        left: 39rem;
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      left: 18rem;
      top: 3.5rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 8rem;
        left: 22rem;
      `:``}
    }
  }
  &.card-2 {
    left: 32rem;
    top: 9.5rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation2} 2s  ${props.rowWise ? '4.5s' : '2s'} infinite`: null};
    
    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 35.2rem;
        left: 39rem;
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      top: 2.5rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 27.2rem;
        left: 22rem;
      `:``}
    }
  }
  &.card-3 {
    left: 46rem;
    top: 12.5rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation1} 2s  ${props.rowWise ? '4.5s' : '2s'} infinite`: null};
    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 39rem;
        left: 13.5rem;
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      top: 6.5rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 34rem;
        left: 1.5rem;
      `:``}
    }
  }
  &.card-4 {
    left: 60rem;
    top: 18.5rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation2} 2s  ${props.rowWise ? '4.5s' : '2s'} infinite`: null};
    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 66.5rem;
        left: 19rem;
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      top: 8.5rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 53.5rem;
        left: 4rem;
      `:``}
    }
  }
  &.card-5 {
    left: 74rem;
    top: 23.5rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation1} 2s  ${props.rowWise ? '4.5s' : '2s'} infinite`: null};
    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 74.3rem;
        left: 43rem;
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      top: 10.2rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 62.3rem;
        left: 22rem;
      `:``}
    }
  }
  &.card-6 {
    left: 88rem;
    top: 24rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation2} 2s  ${props.rowWise ? '4.5s' : '2s'} infinite`: null};
    
    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 99.8rem;
        left: 38rem;
        
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      top: 10.2rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 82.8rem;
        left: 22rem;
      `:``}
    }
  }
  &.card-7 {
    left: 102rem;
    top: 19.5rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation1} 2s  ${props.rowWise ? '4.5s' : '2s'} infinite`: null};
    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 115.6rem;
        left: 13.2rem;
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      top: 8.5rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 93.6rem;
        left: 2.2rem;
      `:``}
    }
  }
  &.card-8 {
    left: 116rem;
    top: 15.5rem;
    transform: ${props => props.rowWise ? css`translateY(0)` : css`translateX(0)`};
    ${props=>props.buildLearningPath ? css` animation: ${skillCardRotation2} 2s  ${props.rowWise ? '4.5s' : '2s'} infinite`: null};

    @media ${device.Tablet}{
      ${props => props.rowWise ? css`
        top: 137.9rem;
        left: 27.6rem;
      `:``}
    }
    @media ${device.PhoneTabletLandscape}{
      top: 9rem;
    }
    @media ${device.Phone}{
      ${props => props.rowWise ? css`
        top: 112.9rem;
        left: 6.6rem;
      `:``}
    }
  }
`;

export const SkillCount = styled.span`
  font: normal 600 1.1rem/1.5rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  color: ${props=>props.colorCat==="practice_and_master" ? indigo: VividViolet};
  @media ${device.PhoneTabletLandscape}{
    font: normal 600 0.8rem/1rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  }
`;

export const SkillName = styled.p`
  font: normal 700 ${props=>props.reduceFontSize ? '1.2rem' : '1.4rem'}/1.6rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  color: ${royal};

  @media ${device.PhoneTabletLandscape}{
    font: normal 600 ${props=>props.reduceFontSize ? '0.8rem' : '1rem'}/1.5rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  }
`;

export const SkillNameWrap = styled.div`
  height: 6rem;
  display: flex;
  align-items: flex-end;
  @media ${device.PhoneTabletLandscape}{
    height: 3.5rem;
  }
`;